namespace Matrix {
    export interface HtmlResponse extends Serenity.ServiceResponse {
        Html?: string;
    }
}
